// File des commandes ouvertes + leurs lignes, réactif (liveQuery), 100 % via
// wrappers (getCommandesEnFile + getLignesCommandes) — INV-C.
import { useLiveQuery } from 'dexie-react-hooks';
import { getCommandesEnFile, getLignesCommandes } from '@/db/transactions';
import type { Commande, CommandePizza, StatutCommande } from '@/db/schema';

export interface FileData {
  commandes: Commande[];
  lignesParCommande: Map<number, CommandePizza[]>;
}

const EMPTY: FileData = { commandes: [], lignesParCommande: new Map() };

export function useFileCommandes(): FileData {
  const data = useLiveQuery(
    async () => {
      const commandes = await getCommandesEnFile();
      const ids = commandes.map((c) => c.id as number);
      const lignes = await getLignesCommandes(ids);
      const lignesParCommande = new Map<number, CommandePizza[]>();
      for (const l of lignes) {
        const arr = lignesParCommande.get(l.commandeId) ?? [];
        arr.push(l);
        lignesParCommande.set(l.commandeId, arr);
      }
      return { commandes, lignesParCommande };
    },
    [],
    EMPTY,
  );
  return data;
}

// pizzasDevant (§4) = Σ qty des lignes des commandes ouvertes dont le statut ∈
// {commandee, priorisee, en_preparation, enfournee, en_finalisation}. 'prete' EXCLU.
const STATUTS_DEVANT: readonly StatutCommande[] = [
  'commandee',
  'priorisee',
  'en_preparation',
  'enfournee',
  'en_finalisation',
];

export function calculerPizzasDevant(file: FileData): number {
  let total = 0;
  for (const c of file.commandes) {
    if (!STATUTS_DEVANT.includes(c.statut)) continue;
    for (const l of file.lignesParCommande.get(c.id as number) ?? []) {
      total += l.qty;
    }
  }
  return total;
}
